import { render, staticRenderFns } from "./Edit-combo.vue?vue&type=template&id=e6876250&scoped=true"
import script from "./Edit-combo.vue?vue&type=script&lang=js"
export * from "./Edit-combo.vue?vue&type=script&lang=js"
import style0 from "./Edit-combo.vue?vue&type=style&index=0&id=e6876250&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6876250",
  null
  
)

export default component.exports